export enum CostUnit {
  EUR = 'EUR',
  USD = 'USD',
}
